/**
 * CNS-15: unticked sign-up opt-ins ("Email me jobs…", "Send me the newsletter").
 *
 * The checkboxes live on the candidate sign-up screens, but the request that
 * creates the account is sent from shared auth code (Google/Apple popups,
 * verification-code and registration OTP stores). The chosen values are kept
 * here (sessionStorage, tab-scoped) until the account is created / the role
 * is set, then cleared.
 *
 * Backend: accounts/social-login/ records them only when it creates the
 * account (ignored for existing users); accounts/update-role/ records only
 * values that change the current state.
 */

const STORAGE_KEY = "haire_signup_consent";
const RECRUITER_ROLES = [1, 5];

const EMPTY = { job_alerts: false, newsletter: false };

let memory = { ...EMPTY };

const read = () => {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...memory };
    const parsed = JSON.parse(raw);
    return {
      job_alerts: parsed?.job_alerts === true,
      newsletter: parsed?.newsletter === true,
    };
  } catch {
    return { ...memory };
  }
};

export function getSignupConsent() {
  return read();
}

export function setSignupConsent(partial) {
  const next = { ...read(), ...(partial || {}) };
  memory = {
    job_alerts: next.job_alerts === true,
    newsletter: next.newsletter === true,
  };
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(memory));
  } catch {
    // Private mode / blocked storage: the in-memory copy still works this page.
  }
  return memory;
}

export function clearSignupConsent() {
  memory = { ...EMPTY };
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/**
 * Body fields for social-login / update-role. Recruiter roles always send
 * false (the checkboxes are candidate-only); anything else sends what the
 * candidate ticked, defaulting to false.
 */
export function signupConsentFields(role) {
  if (RECRUITER_ROLES.includes(Number(role))) {
    return { consent_job_alerts: false, consent_newsletter: false };
  }
  let c = {};
  try {
    c = read() || {};
  } catch (e) {
    c = {}; // never block login / sign-up
  }
  return {
    consent_job_alerts: c.job_alerts === true,
    consent_newsletter: c.newsletter === true,
  };
}
